import { createFileRoute } from '@tanstack/react-router';

import { courtside } from '@/api/sideline';
import { SidelinePage } from '@/components/sideline/SidelinePage';

function Page() {
  return <SidelinePage api={courtside} sport="basketball" />;
}

export const Route = createFileRoute('/custom/courtside')({
  component: Page
});
